import { AxiosRepo } from '@/helpers/interceptorsSetup';
import { CONSTANTS } from '@/constants/guide';

const axiosInstance = AxiosRepo.getInstance();

export const actions = {
  getOrphanPets({ dispatch, commit, state }) {
    return axiosInstance
      .get(`/ivs/Configurator/getOrphanPets`)
      .then(response => {
        if (response)
          commit('setOrphanPets', response);
      })
      .catch(error => {
        console.log(error);
      });
  },
  deleteOrphanPet({ commit }, petId) {
    return axiosInstance
      .post(`/ivs/Configurator/deleteOrphanPets`, {
        petId: petId
      })
      .then(response => {
        if (response === true) {
          commit('deleteOrphanPet', petId);
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  getIntensiveCareProducts({ commit }) {
    return axiosInstance
      .get(`/ivs/Configurator/getIntensiveCareProducts`)
      .then(response => {
        commit('setIntensiveCareProducts', response);
      })
      .catch(error => {
        console.log(error);
      });
  },
  addIntensiveCareToCart({ commit }, payload) {
    return axiosInstance
      .get(`/ivs/Configurator/addIntensiveCareToCart?option=${payload.option}&qty=${payload.qty}`)
      .then(response => {
        return Promise.resolve({
          success: response.status == 1
        });
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          error: error
        });
      });
  },
  getGuidedTourData({ commit }, payload) {
    return axiosInstance
      .post(`/ivs`, { ...payload, Method: 'getGuidedTourData' })
      .then(response => {
        let responseData = response;
        if (responseData?.success === true) {
          if (parseInt(responseData?.sections?.length) > 0) {
            responseData = {
              ...responseData,
              sections: responseData.sections.filter(
                s =>
                  (
                    CONSTANTS.GUIDED_TOUR.SECTIONS?.[
                      payload.pageCode.replace('vet_interface_', '')
                    ] || []
                  ).includes(s.html_id) === true
              )
            };
          }
          commit('setTourData', responseData);
        }
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          error: error
        });
      });
  },
  saveGuidedTourProgress({ commit }, payload) {
    return axiosInstance
      .post(`/ivs`, {
        ...payload,
        pageCode: 'vet_interface_' + payload.pageCode,
        Method: 'saveGuidedTourProgress'
      })
      .then(response => {
        if (response.success === true) {
          commit('deactivateTour');
        }
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          error: error
        });
      });
  }
};
